<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Software Project Management</h1>
		<small class="text-muted">
			From business case to the implementation, we can help with all project management phases.
		</small>
<p class="lead">
Project management responsible for everything in the project, from finding the right direction to planning the time and resources, to adjusting to stakeholders' aims, ensuring effective communication, reacting to changes and finding the solutions. And while project management is indeed a complex task, using the right people, the right tool and methodologies can make a difference between failure and success.
</p>


	<div class="card mx-sm-4 my-4">
		<div class="card-body bg-secondary">
			<h5 class="card-title">Every 2nd project fails</h5>
			<p>
According to statistics, more than 50% of IT projects fail because they run out of time, resources, funds, etc. And most of the failures due to poor project management.
			</p>
		</div>
	</div>



<p>
To help you deliver your next project on time and within a budget, we offer project management, consultation and support services in all stages of software development. Also, we can help you to introduce project management methodologies such as PRINCE2 and AGILE software development best practices to your IT teams.
</p>

		</div>
		<div class="col-lg-4">

			<div class="card my-5">
				<div class="card-body bg-dark text-secondary">
					<h5 class="card-title text-secondary">AI, Blockchain, Smart tech</h5>
					<p class="card-text">Smart technologies are not a new trend any more. It makes applications more efficient and user-oriented, creates publicity for the company, attracts investors and partners.</p>
					<a href="#/innovations" class="btn btn-outline-white">More info</a>
				</div>
			</div>


			<div class="card my-5">
				<div class="card-body bg-success text-secondary">
					<h5 class="card-title text-secondary">Let project to finance itself</h5>
					<p class="card-text">
						We can finance your project where the project can payback the investment when it starts generating revenue.
					</p>
					<a href="#/bot_project_financing" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "service",
				title: "Software Project Management"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
